import { z } from 'zod'

// ----- Schema -----

export const HelpCenterUrlResponseSchema = z.object({
  data: z.object({
    url: z.string(),
  }),
})

export const HelpCenterChatStateResponseSchema = z.object({
  data: z.object({
    chat: z.object({
      unread_message_count: z.number(),
      active: z.boolean(),
    }),
  }),
})

export const CourierChatConfigSchema = z.object({
  delivery: z.object({
    orderId: z.string(),
    name: z.string().nullable(),
    address: z.string().nullable(),
  }),
  translation: z
    .object({
      userPreferredLanguage: z.string(),
    })
    .optional(),
})

export const CourierChatUrlResponseSchema = z.object({
  data: z.object({
    url: z.string(),
    chatConfig: CourierChatConfigSchema,
  }),
})

export const CourierChatDetailsSchema = z.object({
  chatId: z.string(),
  orderId: z.string(),
  unreadMessageCount: z.number(),
  active: z.boolean(),
})

export const CourierChatStateResponseSchema = z.object({
  data: z.object({
    chats: z.array(CourierChatDetailsSchema),
  }),
})

// ----- Types -----

export type CourierChatConfig = z.infer<typeof CourierChatConfigSchema>

export type CourierChatUrlResponse = z.infer<typeof CourierChatUrlResponseSchema>

export type CourierChatDetails = z.infer<typeof CourierChatDetailsSchema>

export type CourierChatStateResponse = z.infer<typeof CourierChatStateResponseSchema>

export type HelpCenterUrlResponse = z.infer<typeof HelpCenterUrlResponseSchema>

export type HelpCenterChatStateResponse = z.infer<typeof HelpCenterChatStateResponseSchema>

export type OrderId = number

export interface CourierChatUrlParams {
  orderId?: number
}

export interface HelpCenterUrlParams {
  orderId?: OrderId
  userId?: number
  countryCode?: string
}

export interface HelpCenterState {
  helpCenterIframeUrl: string | null
  isHelpCenterVisible: boolean
  orderId: OrderId | null
  chat: {
    unreadMessageCount: number
    active: boolean
  }
}

export interface CourierChatState {
  courierChatIframeUrl: string | null
  isCourierChatVisible: boolean
  orderId: OrderId | null
  chats: CourierChatDetails[]
  chatConfig: object
}
